import { POLYGON_TYPE_COMMUNITY, POLYGON_TYPE_LOT, POLYGON_TYPE_POI, POLYGON_TYPE_NEW, POLYGON_POI_FILL, POLYGON_POI_STROKE, POLYGON_COMMUNITY_FILL, POLYGON_COMMUNITY_STROKE, POLYGON_LOT_STROKE, POLYGON_LOT_SOLD_COLOR, POLYGON_LOT_MODEL_COLOR, POLYGON_DEFAULT_FILL, POLYGON_DEFAULT_STROKE, POLYGON_LOT_UNAVAILABLE_COLOR, POLYGON_LOT_FUTURE_UNDER_CONSTRUCTION_COLOR, POLYGON_LOT_MOVE_IN_READY_COLOR, POLYGON_LOT_STATUS_AVAILABLE, POLYGON_LOT_AVAILABLE_COLOR, POLYGON_LOT_STATUS_PENDING, POLYGON_LOT_STATUS_UNRELEASED, POLYGON_LOT_STATUS_CLOSED, POLYGON_LOT_STATUS_SPEC_MODEL, POLYGON_LOT_MAP_STATUS_SOLD, POLYGON_LOT_MAP_STATUS_UNAVAILABLE, POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION, POLYGON_LOT_MAP_STATUS_MOVE_IN_READY, POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE, POLYGON_LOT_MAP_STATUS_MODEL, POLYGON_DISABLED_FILL, POLYGON_DISABLED_STROKE, POLYGON_CMP_STROKE, POLYGON_SELECTED_STROKE, POLYGON_SELECTED_FILL, SHAPE_TYPE_PIN } from './constants';
import settings from './config';
import { LotStatuses } from '../types/filterAndSort';
import { BRAND_CCS } from '../../../common/types/community';
import { findCentroid } from '../../../../js/util/math';
export const getPolygonColors = (polygon, brand, isCurrentClickedPolygon = false, isCurrentHoveredPolygon = false) => {
    let options = {
        fillColor: POLYGON_DEFAULT_FILL,
        fillOpacity: 1,
        strokeColor: POLYGON_DEFAULT_STROKE,
        strokeOpacity: 1,
        strokeWeight: 2
    };
    const polygonType = polygon.Properties.Type;
    const polygonMapStatus = mapStatus(polygon);
    if (polygon.hideOnMap) {
        options.fillColor = POLYGON_DISABLED_FILL;
        options.fillOpacity = 0.1;
        options.strokeColor = POLYGON_DISABLED_STROKE;
        options.strokeWeight = 1;
    }
    else if (polygonType === POLYGON_TYPE_COMMUNITY) {
        options.fillColor = POLYGON_COMMUNITY_FILL;
        options.fillOpacity = 0.4;
        options.strokeColor = brand === BRAND_CCS ? POLYGON_COMMUNITY_STROKE : POLYGON_CMP_STROKE;
        options.strokeWeight = 3;
    }
    else if (polygonType === POLYGON_TYPE_POI) {
        options.fillColor = POLYGON_POI_FILL;
        options.fillOpacity = 1;
        options.strokeColor = POLYGON_POI_STROKE;
        options.strokeWeight = 1;
    }
    else {
        switch (polygonMapStatus) {
            case POLYGON_LOT_MAP_STATUS_SOLD:
                options.fillColor = POLYGON_LOT_SOLD_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                break;
            case POLYGON_LOT_MAP_STATUS_UNAVAILABLE:
                options.fillColor = POLYGON_LOT_UNAVAILABLE_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                break;
            case POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION:
                options.fillColor = POLYGON_LOT_FUTURE_UNDER_CONSTRUCTION_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                options.strokeColor = isCurrentClickedPolygon
                    ? POLYGON_SELECTED_STROKE
                    : POLYGON_LOT_STROKE;
                options.strokeWeight = isCurrentClickedPolygon ? 3 : 2;
                break;
            case POLYGON_LOT_MAP_STATUS_MOVE_IN_READY:
                options.fillColor = POLYGON_LOT_MOVE_IN_READY_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                options.strokeColor = isCurrentClickedPolygon
                    ? POLYGON_SELECTED_STROKE
                    : POLYGON_LOT_STROKE;
                options.strokeWeight = isCurrentClickedPolygon ? 3 : 2;
                break;
            case POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE:
                options.fillColor = POLYGON_LOT_AVAILABLE_COLOR;
                options.strokeColor = isCurrentClickedPolygon
                    ? POLYGON_SELECTED_STROKE
                    : POLYGON_LOT_STROKE;
                options.strokeWeight = isCurrentClickedPolygon ? 3 : 2;
                break;
            case POLYGON_LOT_MAP_STATUS_MODEL:
                options.fillColor = POLYGON_LOT_MODEL_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                break;
            default:
                options.fillColor = POLYGON_LOT_UNAVAILABLE_COLOR;
                options.strokeColor = POLYGON_LOT_STROKE;
                break;
        }
    }
    if (isCurrentHoveredPolygon) {
        options.fillColor = POLYGON_SELECTED_FILL;
    }
    return options;
};
export const mapStatus = (polygon) => {
    const polygonStatus = polygon.Properties.LotStatus;
    switch (polygonStatus) {
        case POLYGON_LOT_MAP_STATUS_SOLD:
        case POLYGON_LOT_STATUS_CLOSED:
        case POLYGON_LOT_STATUS_PENDING:
            return LotStatuses.Sold;
        case POLYGON_LOT_MAP_STATUS_UNAVAILABLE:
        case POLYGON_LOT_STATUS_UNRELEASED:
            return LotStatuses.Unavailable;
        case POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION:
            return LotStatuses.UnderConstruction;
        case POLYGON_LOT_STATUS_SPEC_MODEL:
            let status;
            if (polygon.Properties.IsQuickMoveIn) {
                status = LotStatuses.MoveInReady;
            }
            else if (polygon.Properties.IsModelHome) {
                status = LotStatuses.Model;
            }
            else {
                status = LotStatuses.UnderConstruction;
            }
            return status;
        case POLYGON_LOT_MAP_STATUS_MOVE_IN_READY:
            return LotStatuses.MoveInReady;
        case POLYGON_LOT_STATUS_AVAILABLE:
        case POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE:
            return LotStatuses.Available;
        case POLYGON_LOT_MAP_STATUS_MODEL: //extra condition for Model status
            return LotStatuses.Model;
        default:
            return LotStatuses.Unavailable;
    }
};
export function getStatusColor(polygonMapStatus) {
    let statusColor;
    switch (polygonMapStatus) {
        case POLYGON_LOT_MAP_STATUS_SOLD:
            statusColor = POLYGON_LOT_SOLD_COLOR;
            break;
        case POLYGON_LOT_MAP_STATUS_MODEL: //extra condition for Model status
            statusColor = POLYGON_LOT_MODEL_COLOR;
            break;
        case POLYGON_LOT_MAP_STATUS_UNAVAILABLE:
            statusColor = POLYGON_LOT_UNAVAILABLE_COLOR;
            break;
        case POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION:
            statusColor = POLYGON_LOT_FUTURE_UNDER_CONSTRUCTION_COLOR;
            break;
        case POLYGON_LOT_MAP_STATUS_MOVE_IN_READY:
            statusColor = POLYGON_LOT_MOVE_IN_READY_COLOR;
            break;
        case POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE:
            statusColor = POLYGON_LOT_AVAILABLE_COLOR;
            break;
        default:
            statusColor = POLYGON_LOT_UNAVAILABLE_COLOR;
            break;
    }
    return statusColor;
}
/**
 * To be used to determine what shows in the available lot listing
 */
export function doesPolygonShowAvailable(polygon) {
    const refinedMapStatus = mapStatus(polygon);
    if (refinedMapStatus === POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION ||
        refinedMapStatus === POLYGON_LOT_MAP_STATUS_MOVE_IN_READY ||
        refinedMapStatus === POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE) {
        return true;
    }
    return false;
}
export const getStatusLabel = (polygon) => {
    const polygonMapStatus = mapStatus(polygon);
    switch (polygonMapStatus) {
        case POLYGON_LOT_MAP_STATUS_MODEL:
            return settings['StatusModelLabel'];
        case POLYGON_LOT_MAP_STATUS_SOLD:
            return settings['StatusSoldLabel'];
        case POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE:
            return settings['StatusAvailableHomesiteLabel'];
        case POLYGON_LOT_MAP_STATUS_UNAVAILABLE:
            return settings['StatusUnavailableLabel'];
        case POLYGON_LOT_MAP_STATUS_MOVE_IN_READY:
            return settings['StatusMoveInReadyLabel'];
        case POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION:
            return settings['StatusUnderConstructionLabel'];
        default:
            return 'Unknown status';
    }
};
export const getPolygonIndex = (polygon) => {
    switch (polygon.Properties.Type) {
        case POLYGON_TYPE_NEW:
            return 100;
        case POLYGON_TYPE_LOT:
            return 90;
        case POLYGON_TYPE_POI:
            return 80;
        case POLYGON_TYPE_COMMUNITY:
            return 70;
        default:
            return 0;
    }
};
export function getPolyInfoWindowPosition(polygon) {
    let northPointIndex = 0;
    let maxLatitude = -100;
    const middlePointLng = polygon.Type === SHAPE_TYPE_PIN ? polygon.Coordinates[0][0][1] : getShapeCenter(polygon.Coordinates).lng;
    // set the info window position to northern most point
    polygon.Coordinates[0].forEach((latlng, index) => {
        if (latlng[0] > maxLatitude) {
            maxLatitude = latlng[0];
            northPointIndex = index;
        }
    });
    return {
        lat: polygon.Coordinates[0][northPointIndex][0],
        lng: middlePointLng
    };
}
export function getShapeCenter(coordinates) {
    const center = findCentroid(coordinates[0]);
    return {
        lat: center.X,
        lng: center.Y
    };
}
export function checkStatusAvailability(status) {
    const availableStatuses = [
        POLYGON_LOT_MAP_STATUS_MOVE_IN_READY,
        POLYGON_LOT_MAP_STATUS_UNDER_CONSTRUCTION,
        POLYGON_LOT_MAP_STATUS_AVAILABLE_HOME_SITE
    ];
    return availableStatuses.includes(status);
}
